<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <template v-if="this.link">Link to </template>
        <template v-else>Unlink from </template>
        Parent Account
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <message :messages="messages"></message>
          <div class="body-2">
            GL Account No. &nbsp;
            <v-icon @click="doHelplist" v-if="link">mdi-magnify</v-icon>
          </div>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                label="Account No."
                v-model="parentAcctForm.parentAcctNo"
                :error-messages="errors.collect('parentAcctNo')"
                data-vv-name="parentAcctNo"
                data-vv-as="Account No."
                v-validate="'required'"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="Fund"
                v-model="parentAcctForm.parentFund"
                :error-messages="errors.collect('parentFund')"
                data-vv-name="parentFund"
                data-vv-as="Fund"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="Account No. Suffix"
                v-model="parentAcctForm.parentAcctNoSfx"
                :error-messages="errors.collect('parentAcctNoSfx')"
                data-vv-name="parentAcctNoSfx"
                data-vv-as="Account No. Suffix"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn color="error" dark flat @click="$emit('close')">Cancel</v-btn>
            <v-btn color="primary" dark flat @click="doSave">Save</v-btn>
          </v-layout>
        </v-container>
        <v-dialog v-model="helplist" width="800px" persistent>
          <helplist
            :key="helplist"
            :fieldKey1="helplistFieldKey1"
            :apiURI="helplistURI"
            :fieldList="helplistFields"
            :expand="helplistExpand"
            @select="doSelect($event)"
            @close="doClose"
          ></helplist>
        </v-dialog>
      </v-card-text>
      <warning ref="warning" :label="msg"></warning>
      <confirm ref="confirm" :label="msg"></confirm>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'
import Helplist from '@/components/parameters/helplist/helplist'

export default {
  data() {
    return {
      helplist: false,
      dialog: false,
      parentAcctForm: {
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null
      },
      helplistExpand: null,
      helplistFieldKey1: 'parentAcct',
      helplistURI: null,
      helplistFields: [
        { text: 'Parent Account No.', value: 'glacctNo' },
        { text: 'Parent Fund', value: 'fund' },
        { text: 'Parent Account No. Suffix', value: 'acctNoSfx' }
      ],
      msg: null
    }
  },
  created() {
    this.loadHelplist()
    if (this.link) {
      this.doLinkInit()
    } else {
      this.doUnlinkInit()
    }
  },
  methods: {
    async loadHelplist() {
      const apiURI = this.menu.parentAcctHelplist
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.helplistURI = extractMenu(result.data._links).parentAcctHelplist
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(result) {
      if (result && result.fieldKey1 && result.data) {
        this.parentAcctForm.parentAcctNo = result.data.glacctNo
        this.parentAcctForm.parentFund = result.data.fund
        this.parentAcctForm.parentAcctNoSfx = result.data.acctNoSfx
      }
    },
    doLinkInit() {},
    doUnlinkInit() {
      if (this.parentAcct) {
        this.parentAcctForm.parentAcctNo = this.parentAcct.parentAcctNo
        this.parentAcctForm.parentFund = this.parentAcct.parentFund
        this.parentAcctForm.parentAcctNoSfx = this.parentAcct.parentAcctNoSfx
      }
    },
    async doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.link) {
            this.doLink()
          } else {
            this.doUnlink()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doLink() {
      const validateParent = await this.validateParent()
      if (validateParent.valid) {
        const apiURI = this.menu.linkParent
        if (apiURI) {
          try {
            const formData = {
              branch: this.glacctNoId.branch,
              glacctNo: this.glacctNoId.glacctNo,
              fund: this.glacctNoId.fund,
              acctNoSfx: this.glacctNoId.acctNoSfx,
              parentAcctNo: this.parentAcctForm.parentAcctNo,
              parentFund: this.parentAcctForm.parentFund,
              parentAcctNoSfx: this.parentAcctForm.parentAcctNoSfx,
              updateMix: validateParent.updateMix
            }
            const result = await this.$http.post(apiURI, formData)
            const { data } = result
            this.notify(data)
            this.$emit('close', true)
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    async validateParent() {
      const apiURI = this.menu.validateParent
      if (apiURI) {
        try {
          const expand = {
            branch: this.glacctNoId.branch,
            cGlacctNo: this.glacctNoId.glacctNo,
            cFund: this.glacctNoId.fund,
            cAcctNoSfx: this.glacctNoId.acctNoSfx,
            pGlacctNo: this.parentAcctForm.parentAcctNo,
            pFund: this.parentAcctForm.parentFund,
            pAcctNoSfx: this.parentAcctForm.parentAcctNoSfx
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const data = result.data.messages
          let valid = true
          for (let i = 0; i < data.length; i++) {
            let msg = data[i]
            if (msg.type === 'WARN') {
              this.msg = msg.message
              const prompt = await this.$refs.warning.doPopUp()
              if (!prompt) {
                valid = false
                break
              }
            } else if (msg.type === 'SUCCESS') {
              return {
                valid: true,
                updateMix: false
              }
            }
          }
          if (valid) {
            return {
              valid: true,
              updateMix: true
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return {
            valid: false
          }
        }
      } else {
        this.$toast.error('Validate Parent API not existed')
        return {
          valid: false
        }
      }
    },
    async doUnlink() {
      this.msg = 'Are you sure you want to unlink?'
      const confirm = await this.$refs.confirm.doPopUp()
      if (confirm) {
        const apiURI = this.menu.unlinkParent
        if (apiURI) {
          try {
            const result = await this.$http.put(apiURI, this.glacctNoId)
            const { data } = result
            this.notify(data)
            this.$emit('close', true)
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.$toast.error('Unlink Parent API is not existed')
        }
      }
    },
    doHelplist() {
      this.helplistExpand = {
        branch: this.glacctNoId.branch,
        glacctNo: this.glacctNoId.glacctNo,
        fund: this.glacctNoId.fund,
        acctNoSfx: this.glacctNoId.acctNoSfx,
        postType: this.glacctNoId.postType,
        curr: this.glacctNoId.curr
      }
      this.dialog = true
      this.helplist = true
    },
    doClose() {
      this.helplist = false
      this.dialog = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  components: {
    Helplist
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    link: Boolean,
    comp: Object,
    parentAcct: Object
  }
}
</script>

<style>
</style>
